var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.91 8h3.853m3.146.795L5 12.454c-.62.327-.93.491-1.134.444a.56.56 0 0 1-.393-.332c-.08-.194.03-.527.252-1.192l1.03-3.09c.035-.105.053-.158.06-.212a.6.6 0 0 0 0-.144 1 1 0 0 0-.058-.205L3.724 4.626c-.222-.665-.332-.998-.252-1.192a.56.56 0 0 1 .393-.332c.204-.048.514.116 1.133.444l6.911 3.659c.487.258.73.387.81.559.07.15.07.322 0 .472-.079.172-.322.3-.81.559z"
  })));
};
export { SvgSend as ReactComponent };
export default __webpack_public_path__ + "1d9bd59df55b1f52ec2ff3486cad129e.svg";